import { Anchor, Stack, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useTranslation } from '@refinedev/core';
import { Link } from 'react-router-dom';
import { useClaimPaginationStore } from 'store/ClaimPaginationStore';
import { useClaimTabFilterStore } from 'store/ClaimTabFilterStore';
import { useCurrentSiteStore } from 'store/SiteStore';

export const useClaimBatchCreatedNotification = (): ((
  batchID: string
) => void) => {
  const { translate } = useTranslation();
  const site = useCurrentSiteStore();

  return (batchID: string): void => {
    const notificationID = `claim-batch-created-${batchID}`;
    notifications.show({
      id: notificationID,
      title: translate('pages:claims.batchCreated.title', 'Claims created'),
      message: (
        <Stack gap="xs">
          <Text size="sm" c="inherit">
            {translate(
              'pages:claims.batchCreated.description',
              'The batch was saved.'
            )}
          </Text>
          <Anchor
            component={Link}
            to="/claims"
            onClick={() => {
              useCurrentSiteStore.getState().setCurrentSite(site);
              useClaimTabFilterStore.setState({
                activeTab: 'all',
                selectedTariffStatuses: [],
                providerNeedsAction: false,
                tariffRowFilterMode: 'showAllTariffs',
              });
              useClaimPaginationStore.getState().setPagination((previous) => ({
                ...previous,
                pageIndex: 0,
                globalFilter: '',
                columnFilters: [{ id: 'batchID', value: batchID }],
              }));
              notifications.hide(notificationID);
            }}
          >
            {translate('pages:claims.batchCreated.viewBatch', 'View batch')}
          </Anchor>
        </Stack>
      ),
      color: 'teal',
      position: 'top-right',
      autoClose: false,
      withCloseButton: true,
      withBorder: true,
    });
  };
};
